import { useState, useEffect, useRef } from 'react'

export default function CurrencyInput({ name, defaultValue, value, onChange, placeholder, required, className = 'input', showZero = true }) {
  const formatValue = (val) => {
    if (val === undefined || val === null || val === '' || val === 0 || val === '0') return ''
    return new Intl.NumberFormat('ru-RU').format(val)
  }

  const [localVal, setLocalVal] = useState(() => {
    const initVal = value !== undefined ? value : defaultValue
    return formatValue(initVal)
  })
  const [isFocused, setIsFocused] = useState(false)

  // Sync with value prop if it's controlled
  useEffect(() => {
    if (value !== undefined && !isFocused) {
      if (!value || value === '0' || value === 0) {
        setLocalVal('')
      } else if (String(value).replace(/\D/g, '') !== localVal.replace(/\D/g, '')) {
        setLocalVal(new Intl.NumberFormat('ru-RU').format(value))
      }
    }
  }, [value])

  const handleChange = (e) => {
    let raw = e.target.value.replace(/[^\d.,]/g, '').replace(/,/g, '.')
    if (!raw) {
      setLocalVal('')
      if (onChange) onChange('')
      return
    }
    // Allow typing decimal point
    if (raw.endsWith('.')) {
      setLocalVal(new Intl.NumberFormat('ru-RU').format(raw.slice(0, -1)) + '.')
      if (onChange) onChange(raw)
      return
    }
    const parts = raw.split('.')
    let formatted = new Intl.NumberFormat('ru-RU').format(parts[0])
    if (parts.length > 1) {
      formatted += '.' + parts[1].slice(0, 2)
    }
    setLocalVal(formatted)
    if (onChange) onChange(raw)
  }

  const handleFocus = () => {
    setIsFocused(true)
    // Если значение «0», стираем для удобства ввода
    if (localVal === '0' || localVal === '') {
      setLocalVal('')
    }
  }

  const handleBlur = () => {
    setIsFocused(false)
    // Если поле пустое и showZero — ставим «0»
    if (!localVal && showZero) {
      setLocalVal('0')
      if (onChange) onChange('0')
    }
  }

  // Display value: если не в фокусе и пусто — показать «0» (если showZero)
  const displayValue = (!isFocused && !localVal && showZero) ? '0' : localVal

  return (
    <>
      <input type="hidden" name={name} value={localVal.replace(/\s/g, '')} />
      <input
        type="text"
        className={className}
        required={required}
        placeholder={placeholder || (showZero ? '0' : '')}
        value={displayValue}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
      />
    </>
  )
}
